export default __webpack_public_path__ + "static/media/gym.a306cf1f.jpg";